// Translations for the Nimny website
// Supported languages: EN (English), ES (Spanish), RU (Russian)

export const translations = {
  // Navigation
  nav: {
    meetNimny: {
      en: 'Meet Nimny',
      es: 'Conocer a Nimny',
      ru: 'Познакомиться с Нимни'
    },
    stories: {
      en: 'Stories',
      es: 'Historias',
      ru: 'Сказки'
    },
    updates: {
      en: 'Updates',
      es: 'Actualizaciones',
      ru: 'Обновления'
    },
    readOnAmazon: {
      en: 'Read on Amazon',
      es: 'Leer en Amazon',
      ru: 'Читать на Amazon'
    },
    readOnline: {
      en: 'Read stories',
      es: 'Leer historias',
      ru: 'Читать сказки'
    },
    read: {
      en: 'Read',
      es: 'Leer',
      ru: 'Читать'
    },
    createStory: {
      en: 'Create your own story',
      es: 'Crea tu propio cuento',
      ru: 'Создай свою сказку'
    }
  },

  // Hero Section
  hero: {
    headline: {
      en: 'Nimny Stories',
      es: 'Cuentos de Nimny',
      ru: 'Сказки от Нимни'
    },
    subheadline: {
      en: 'A gentle bedtime ritual — to read, listen, talk, or create together.',
      es: 'Un ritual suave para dormir — para leer, escuchar, hablar o crear juntos.',
      ru: 'Мягкий ритуал перед сном — читать, слушать, говорить или создавать вместе.'
    },
    kindleNote: {
      en: 'Available on Kindle and online',
      es: 'Disponible en Kindle y en línea',
      ru: 'Доступно в Kindle и онлайн'
    }
  },

  // Features Section (3 cards)
  features: {
    card1: {
      title: {
        en: 'Calms the nervous system',
        es: 'Calma el sistema nervioso',
        ru: 'Успокаивает нервную систему'
      }
    },
    card2: {
      title: {
        en: 'Designed to read or listen together',
        es: 'Diseñado para leer o escuchar juntos',
        ru: 'Создано для чтения или прослушивания вместе'
      }
    },
    card3: {
      title: {
        en: 'Built for calm bedtime moments',
        es: 'Hecho para momentos tranquilos antes de dormir',
        ru: 'Создано для спокойных вечерних моментов'
      }
    }
  },

  // About/Meet Nimny Section
  about: {
    title: {
      en: 'Who is Nimny?',
      es: '¿Quién es Nimny?',
      ru: 'Кто такая Нимни?'
    },
    // Images per language (optimized JPG cards)
    image: {
      en: '/assets/migrated/2a9d8910c9c3f9de.jpg',
      es: '/assets/migrated/ac3b359092f84bc3.jpg',
      ru: '/assets/migrated/d2758fbd3d16a456.jpg'
    }
  },

  // Stories Section
  stories: {
    week1Label: {
      en: 'Week 1',
      es: 'Semana 1',
      ru: 'Неделя 1'
    },
    sectionTitle: {
      en: 'Seven Cozy Bedtime Tales',
      es: 'Siete Acogedores Cuentos para Dormir',
      ru: 'Семь Уютных Сказок на Ночь'
    },
    sectionSubtitle: {
      en: 'One story for each night of the week.',
      es: 'Una historia para cada noche de la semana.',
      ru: 'По одной сказке на каждый день недели.'
    },
    readOnlineTitle: {
      en: 'Read Online',
      es: 'Leer en línea',
      ru: 'Читать онлайн'
    },
    readOnlineDescription: {
      en: 'Four weeks of gentle bedtime stories, together in the Nimny reading app.',
      es: 'Cuatro semanas de suaves cuentos para dormir, reunidos en la aplicación de lectura de Nimny.',
      ru: 'Четыре недели добрых сказок на ночь в приложении для чтения Nimny.'
    },
    onlineCollectionTitle: {
      en: 'Four weeks. One gentle bedtime ritual.',
      es: 'Cuatro semanas. Un suave ritual para dormir.',
      ru: 'Четыре недели. Один добрый вечерний ритуал.'
    },
    onlineCollectionBody: {
      en: 'Open the Nimny reading app to explore all four weeks and choose a story for tonight.',
      es: 'Abre la aplicación de lectura de Nimny para explorar las cuatro semanas y elegir un cuento para esta noche.',
      ru: 'Откройте приложение Nimny, чтобы увидеть все четыре недели и выбрать сказку на сегодняшний вечер.'
    },
    openOnlineCollection: {
      en: 'Open Nimny Stories',
      es: 'Abrir Cuentos de Nimny',
      ru: 'Открыть сказки Nimny'
    },
    onlineCollectionAlt: {
      en: 'Four weeks of Nimny Bedtime Stories',
      es: 'Cuatro semanas de Cuentos de Nimny para dormir',
      ru: 'Четыре недели сказок Nimny на ночь'
    },
    onlineCollectionCover: '/assets/books/nimny-bedtime-stories-four-weeks.jpg',
    readOnAmazonTitle: {
      en: 'Read on Amazon',
      es: 'Leer en Amazon',
      ru: 'Читать на Amazon'
    },
    // Day labels (Day 1-7 format)
    dayLabel: {
      en: 'Day',
      es: 'Día',
      ru: 'День'
    },
    // Cover images (optimized)
    onlineCover: '/assets/migrated/b9c4c17b585449db.jpg',
    amazonCover: '/assets/migrated/5e95bdd81f38b9d1.jpg',
    // Online stories (Week 1)
    onlineStories: {
      en: [
        'The Space Between Rooms',
        'The Thought That Didn\'t Need an Answer Tonight',
        'The Blanket as a Border',
        'The Body That Was Tired Before the Mind',
        'The Promise That Could Wait',
        'The Night Sounds That Were Actually Friendly',
        'The Tomorrow That Could Wait'
      ],
      es: [
        'El espacio entre las habitaciones',
        'El pensamiento que no necesitaba respuesta esta noche',
        'La manta como frontera',
        'El cuerpo que se cansó antes que la mente',
        'La promesa que podía esperar',
        'Los sonidos de la noche que en realidad eran amigos',
        'El mañana que podía esperar'
      ],
      ru: [
        'Пространство между комнатами',
        'Мысль, которой сегодня не нужен был ответ',
        'Одеяло как граница',
        'Тело, которое устало раньше разума',
        'Обещание, которое могло подождать',
        'Ночные звуки, которые оказались друзьями',
        'Завтра, которое могло подождать'
      ]
    },
    // Amazon stories (Week 1) - titles only, day labels will be generated
    amazonStories: {
      en: [
        'The Acorn Lantern and the Missing Sock',
        'The Under-the-Stairs Station',
        'The Top-Shelf Glove Mystery',
        'The Blanket-Fort Treaty',
        'The Whispering Dishwasher',
        'The Too-Loud Midnight Snack',
        'Cozy Recharge'
      ],
      es: [
        'La linterna de bellota y el calcetín perdido',
        'La estación bajo la escalera',
        'El misterio del guante en el estante alto',
        'El tratado del fuerte de mantas',
        'El lavavajillas susurrante',
        'El tentempié nocturno demasiado ruidoso',
        'Recarga acogedora'
      ],
      ru: [
        'Жёлудь-фонарик и потерянный носок',
        'Станция под лестницей',
        'Тайна перчатки на верхней полке',
        'Договор о крепости из одеял',
        'Шепчущая посудомоечная машина',
        'Слишком громкий полуночный перекус',
        'Тихая перезагрузка'
      ]
    }
  },

  // Email Signup Section
  email: {
    headline: {
      en: 'Get Updates',
      es: 'Recibir novedades',
      ru: 'Получать обновления'
    },
    description: {
      en: 'One gentle story and family question, quietly delivered each week.',
      es: 'Una historia amable y una pregunta para la familia, cada semana.',
      ru: 'Одна добрая история и семейный вопрос — каждую неделю.'
    },
    buttonText: {
      en: 'Notify me',
      es: 'Avisarme',
      ru: 'Уведомить меня'
    },
    placeholder: {
      en: 'your@email.com',
      es: 'tu@email.com',
      ru: 'ваш@email.com'
    },
    privacyNote: {
      en: 'Weekly Nimny story updates only. Unsubscribe anytime.',
      es: 'Solo novedades semanales de Nimny. Cancela cuando quieras.',
      ru: 'Только еженедельные новости Нимни. Отписаться можно в любой момент.'
    },
    sending: {
      en: 'Sending...',
      es: 'Enviando...',
      ru: 'Отправка...'
    },
    subscribed: {
      en: 'Check your inbox',
      es: 'Revisa tu correo',
      ru: 'Проверьте почту'
    }
  },

  // Footer
  footer: {
    contact: {
      en: 'Contact',
      es: 'Contacto',
      ru: 'Контакты'
    },
    privacy: {
      en: 'Privacy',
      es: 'Política de privacidad',
      ru: 'Политика конфиденциальности'
    },
    about: {
      en: 'About',
      es: 'Acerca de',
      ru: 'О нас'
    }
  },

  // Video Section
  video: {
    peek: {
      en: "Meet Nimny. In real life.",
      es: "Conoce a Nimny. En la vida real.",
      ru: "Познакомьтесь с Нимни. В реальной жизни."
    }
  },

  // Intro Section (above Hero)
  intro: {
    line1: {
      en: "Nimny is a collection of bedtime stories",
      es: "Nimny es una colección de cuentos para dormir",
      ru: "Нимни — это сборник сказок на ночь,"
    },
    line2: {
      en: "to read, listen, or create together",
      es: "para leer, escuchar o crear juntos",
      ru: "чтобы читать, слушать или создавать вместе"
    },
    line3: {
      en: "before sleep.",
      es: "antes de dormir.",
      ru: "перед сном."
    },
    tagline: {
      en: "Be there for your child.",
      es: "Quédate con tu hijo.",
      ru: "Будьте рядом со своим ребёнком."
    }
  },

  // Printed Edition Section
  printed: {
    badge: {
      en: 'New release',
      es: 'Nuevo lanzamiento',
      ru: 'Новый релиз'
    },
    description: {
      en: 'The first printed Nimny book is now available on Amazon, with a Kindle edition for digital reading.',
      es: 'El primer libro impreso de Nimny ya está disponible en Amazon, con una edición Kindle para lectura digital.',
      ru: 'Первая печатная книга Nimny уже доступна на Amazon, а для цифрового чтения представлена версия Kindle.'
    },
    button: {
      en: 'View on Amazon',
      es: 'Ver en Amazon',
      ru: 'Открыть на Amazon'
    },
    format: {
      en: 'Print + Kindle',
      es: 'Impreso + Kindle',
      ru: 'Печатная версия + Kindle'
    }
  },

  // SEO Content Section
  seo: {
    title: {
      en: 'What Is Nimny?',
      es: '¿Qué es Nimny?',
      ru: 'Что такое Нимни?'
    },
    paragraph1: {
      en: 'Nimny is a collection of original bedtime stories for children, designed to be read aloud by parents. These calming night stories help children gently transition from the busy rhythm of the day into rest.',
      es: 'Nimny es una colección de cuentos originales para la hora de dormir, diseñados para ser leídos en voz alta por los padres. Estas historias tranquilas ayudan a los niños a pasar suavemente del ritmo activo del día al descanso.',
      ru: 'Нимни — это коллекция оригинальных сказок на ночь для детей, предназначенных для чтения вслух родителями. Эти спокойные истории помогают мягко перейти от насыщенного дня к отдыху.'
    },
    createFeature: {
      en: 'Now you can create a personal bedtime story, too. Share a theme, a feeling, or a small moment from the day, and Nimny will gently shape a calm story you can read—or listen to—right away.',
      es: 'Ahora también puedes crear un cuento personal para la hora de dormir. Comparte un tema, una emoción o un pequeño momento del día, y Nimny dará forma a un cuento tranquilo que podrás leer — o escuchar — al instante.',
      ru: 'Теперь ты можешь создать персональную сказку на ночь. Расскажи тему, настроение или маленький момент дня — и Нимни мягко сложит спокойную историю, которую можно сразу прочитать или послушать.'
    },
    createLink: {
      en: 'Create your story',
      es: 'Crear tu cuento',
      ru: 'Создать свою сказку'
    },
    paragraph2: {
      en: 'Each Nimny story is written as a soft emotional ritual — not to teach lessons, but to create safety, connection, and quiet moments before sleep. The stories are structured by weeks and months, allowing families to build a steady bedtime routine.',
      es: 'Cada historia de Nimny funciona como un pequeño ritual emocional nocturno — no para enseñar lecciones, sino para crear seguridad, conexión y calma antes de dormir. Las historias están organizadas por semanas y meses para construir una rutina constante.',
      ru: 'Каждая история Нимни построена как тихий эмоциональный ритуал — не для уроков, а для ощущения безопасности, близости и спокойствия перед сном. Сказки организованы по неделям и месяцам, чтобы формировать устойчивую вечернюю традицию.'
    },
    listIntro: {
      en: 'Nimny bedtime stories are ideal for children who:',
      es: 'Los cuentos de Nimny son ideales para niños que:',
      ru: 'Сказки Нимни особенно подходят детям, которые:'
    },
    listItem1: {
      en: 'need help calming down before sleep',
      es: 'necesitan ayuda para calmarse antes de dormir',
      ru: 'трудно успокаиваются перед сном'
    },
    listItem2: {
      en: 'think a lot at night',
      es: 'piensan mucho por la noche',
      ru: 'много думают ночью'
    },
    listItem3: {
      en: 'feel big emotions in small moments',
      es: 'sienten emociones intensas',
      ru: 'ярко переживают эмоции'
    },
    listItem4: {
      en: 'enjoy quiet storytelling instead of screens',
      es: 'prefieren historias tranquilas en lugar de pantallas',
      ru: 'предпочитают тихое чтение вместо экранов'
    },
    closing: {
      en: 'Unlike fast-paced children\'s content, Nimny focuses on stillness, reassurance, and emotional balance.',
      es: 'Nimny no es contenido acelerado. Es una experiencia suave y reconfortante para la noche.',
      ru: 'Нимни — это не быстрый контент. Это мягкий, спокойный опыт вечернего чтения.'
    },
    learnMore: {
      en: 'Learn more about Nimny',
      es: 'Más sobre Nimny',
      ru: 'Подробнее о Нимни'
    }
  },

  // Where to Read Section (Cross-Domain SEO)
  whereToRead: {
    title: {
      en: 'Where to Read Nimny',
      es: 'Dónde leer Nimny',
      ru: 'Где читать Нимни'
    },
    description: {
      en: 'Nimny stories are available inside the Nimny reading app at',
      es: 'Las historias de Nimny están disponibles en la aplicación de lectura de Nimny en',
      ru: 'Истории Нимни доступны в приложении для чтения на'
    },
    appName: {
      en: 'nimny.app',
      es: 'nimny.app',
      ru: 'nimny.app'
    },
    details: {
      en: 'The app provides structured access to all weeks and months of bedtime stories in English, Russian, and Spanish.',
      es: 'La aplicación proporciona acceso estructurado a todas las semanas y meses de cuentos para dormir en inglés, ruso y español.',
      ru: 'Приложение предоставляет структурированный доступ ко всем неделям и месяцам сказок на ночь на английском, русском и испанском языках.'
    },
    openApp: {
      en: 'Open Nimny App',
      es: 'Abrir aplicación Nimny',
      ru: 'Открыть приложение Нимни'
    }
  },

  // About Page - Expanded Content
  aboutPage: {
    metaTitle: {
      en: 'About Nimny – Bedtime Stories for Children',
      es: 'Sobre Nimny – Cuentos para dormir para niños',
      ru: 'О Нимни – Сказки на ночь для детей'
    },
    metaDescription: {
      en: 'Learn about Nimny, a collection of calming bedtime stories for children designed to be read aloud and support emotional nighttime routines.',
      es: 'Conoce Nimny, una colección de cuentos tranquilos para dormir diseñados para leerse en voz alta y crear una rutina nocturna emocionalmente segura.',
      ru: 'Узнайте о Нимни — коллекции спокойных сказок на ночь, созданных для чтения вслух и мягкого вечернего ритуала.'
    },
    title: {
      en: 'About',
      es: 'Acerca',
      ru: 'О проекте'
    },
    intro1: {
      en: 'Nimny is a growing collection of original bedtime stories for children — designed to be read aloud, listened to, or created together.',
      es: 'Nimny es una colección creciente de cuentos originales para la hora de dormir — diseñados para leer en voz alta, escuchar o crear juntos.',
      ru: 'Нимни — это растущая коллекция авторских сказок на ночь. Их можно читать вслух, слушать или создавать вместе.'
    },
    intro2: {
      en: 'But Nimny is also something more specific: a quiet helper for the part of the day when families are tired, children are full of thoughts, and the house is still carrying the noise of everything that happened.',
      es: 'Pero Nimny es algo más específico: una presencia tranquila para ese momento del día en que la familia está cansada, los pensamientos siguen activos y la casa todavía guarda el eco de todo lo vivido.',
      ru: 'Но Нимни — это ещё и тихий помощник. Для той части вечера, когда семья устала, мысли ребёнка всё ещё кружатся, а в доме ещё слышен шум прожитого дня.'
    },
    // What you can do now section
    whatYouCanDoTitle: {
      en: 'What you can do now',
      es: 'Qué puedes hacer ahora',
      ru: 'Что можно делать сейчас'
    },
    whatYouCanDoList: {
      en: [
        'Read Month One — follow weeks and stories at your own pace',
        'Listen with Play — tap the play button and let Nimny narrate',
        'Create your own stories — personalized tales saved to My Stories',
        'Talk to Nimny — a gentle voice companion for bedtime moments',
        'Living Story Mode — interactive stories where your child\'s answers shape the tale'
      ],
      es: [
        'Lee el Mes Uno — sigue las semanas e historias a tu ritmo',
        'Escucha con Play — toca el botón y deja que Nimny narre',
        'Crea tus propios cuentos — historias personalizadas guardadas en Mis Cuentos',
        'Habla con Nimny — un compañero de voz suave para la hora de dormir',
        'Modo Historia Viva — historias interactivas donde las respuestas de tu niño dan forma al cuento'
      ],
      ru: [
        'Читай Месяц Первый — недели и истории в своём темпе',
        'Слушай с Play — нажми кнопку, и Нимни расскажет',
        'Создавай свои сказки — они сохраняются в Мои Истории',
        'Говори с Нимни — мягкий голосовой спутник перед сном',
        'Режим Живой Истории — интерактивные сказки, где ответы ребёнка меняют сюжет'
      ]
    },
    whoIsNimnyTitle: {
      en: 'Who is Nimny?',
      es: '¿Quién es Nimny?',
      ru: 'Кто такая Нимни?'
    },
    whoIsNimny1: {
      en: 'Nimny is a small, gentle night companion — not a superhero, not a teacher, and not a voice that tells children what they "should" feel.',
      es: 'Nimny es una pequeña compañera nocturna. No es una superheroína ni una maestra, ni una voz que dice a los niños lo que "deberían" sentir.',
      ru: 'Нимни — маленькая ночная спутница. Не супергерой, не наставник и не голос, который говорит, что ребёнок «должен» чувствовать.'
    },
    whoIsNimny2: {
      en: 'She appears in the moments when a day is too heavy to put down all at once. Nimny doesn\'t fight the night. She simply makes it softer.',
      es: 'Aparece cuando el día es demasiado pesado para soltarlo de golpe. No lucha contra la noche; simplemente la vuelve más suave.',
      ru: 'Она появляется, когда день слишком тяжёл, чтобы отпустить его сразу. Нимни не борется с ночью — она делает её мягче.'
    },
    sometimesIntro: {
      en: 'Sometimes she fixes one tiny thing:',
      es: 'A veces arregla una sola cosa pequeña:',
      ru: 'Иногда она исправляет одну маленькую вещь:'
    },
    sometimesList: {
      en: ['a blanket that slipped,', 'a light that feels too bright,', 'a worry that won\'t stop circling,', 'a thought that doesn\'t need an answer tonight.'],
      es: ['una manta que se deslizó,', 'una luz demasiado brillante,', 'una preocupación que no deja de girar,', 'un pensamiento que no necesita respuesta esta noche.'],
      ru: ['соскользнувшее одеяло,', 'слишком яркий свет,', 'мысль, которая крутится без остановки,', 'переживание, которому не нужен ответ сегодня.']
    },
    sometimesClosing: {
      en: 'And sometimes she does nothing at all — because the most important thing is to feel safe enough to rest.',
      es: 'Y a veces no hace nada — porque lo más importante antes de dormir es sentirse seguro.',
      ru: 'А иногда она не делает ничего — потому что самое важное чувство перед сном — это безопасность.'
    },
    personalStory: {
      en: 'Sometimes she brings a story that fits tonight exactly—made for your child, in the moment.',
      es: 'A veces trae un cuento que encaja justo con esta noche—hecho para tu niño, en ese momento.',
      ru: 'Иногда она приносит сказку, которая подходит именно для этого вечера — прямо для твоего ребёнка, здесь и сейчас.'
    },
    differentTitle: {
      en: 'What makes Nimny different?',
      es: '¿Qué hace diferente a Nimny?',
      ru: 'Чем Нимни отличается?'
    },
    different1: {
      en: 'Many children\'s stories are built around lessons.',
      es: 'Muchos cuentos infantiles están construidos alrededor de lecciones.',
      ru: 'Многие детские сказки построены вокруг уроков.'
    },
    different2: {
      en: 'Nimny is built around relief.',
      es: 'Nimny está construida alrededor del alivio.',
      ru: 'Нимни — про облегчение.'
    },
    different3: {
      en: 'These stories aren\'t meant to teach children "the right way to behave." They\'re meant to help children slow down and feel held.',
      es: 'Estas historias no enseñan "cómo portarse bien". Ayudan a desacelerar, a sentirse acompañado y a entrar en el descanso con suavidad.',
      ru: 'Эти сказки не учат «как правильно». Они помогают замедлиться, почувствовать поддержку и перейти ко сну мягко.'
    },
    focusIntro: {
      en: 'Nimny bedtime stories focus on:',
      es: 'Los cuentos de Nimny ayudan a:',
      ru: 'Сказки Нимни помогают:'
    },
    focusList: {
      en: ['emotional safety and calm', 'gentle transitions into sleep', 'stillness instead of stimulation', 'connection instead of performance', 'reassurance instead of pressure'],
      es: ['calmarse antes de dormir', 'soltar el ritmo acelerado del día', 'reducir la ansiedad nocturna', 'fortalecer el vínculo familiar', 'crear una rutina constante'],
      ru: ['успокоиться перед сном', 'пережить насыщенный день', 'снизить тревожность', 'почувствовать связь с родителями', 'создать устойчивый вечерний ритуал']
    },
    ritualsTitle: {
      en: 'Why bedtime rituals matter',
      es: '¿Por qué importa el ritual nocturno?',
      ru: 'Почему важен вечерний ритуал'
    },
    rituals1: {
      en: 'Bedtime is not just the end of the day.',
      es: 'La hora de dormir no es solo el final del día.',
      ru: 'Вечер — это не просто конец дня.'
    },
    rituals2: {
      en: 'For children, it\'s often the moment when the mind gets louder.',
      es: 'Para muchos niños, es cuando la mente se vuelve más ruidosa.',
      ru: 'Именно в это время мысли часто становятся громче.'
    },
    ritualsPoetic: {
      en: ['Questions show up.', 'Small regrets return.', 'Worries grow bigger in the dark.', 'Even happy kids can suddenly feel unsettled.'],
      es: ['Aparecen preguntas.', 'Regresan pequeños arrepentimientos.', 'Las emociones crecen en la oscuridad.'],
      ru: ['Появляются вопросы.', 'Возвращаются мелкие сожаления.', 'Переживания кажутся больше в темноте.']
    },
    ritualsClosingIntro: {
      en: 'Nimny stories give families a simple ritual:',
      es: 'Nimny ofrece un ritual sencillo:',
      ru: 'Сказки Нимни создают простой ритуал:'
    },
    ritualsClosingPoetic: {
      en: ['a quiet voice,', 'a steady rhythm,', 'and permission to pause.'],
      es: ['una voz tranquila,', 'un ritmo constante,', 'permiso para hacer una pausa.'],
      ru: ['тихий голос,', 'спокойный ритм,', 'разрешение сделать паузу.']
    },
    structureTitle: {
      en: 'How the stories are structured',
      es: 'Cómo están estructuradas las historias',
      ru: 'Как устроены истории'
    },
    structure1: {
      en: 'Nimny is structured by weeks and months.',
      es: 'Nimny está organizada por semanas y meses.',
      ru: 'Нимни устроена по неделям и месяцам.'
    },
    structure2: {
      en: 'That is intentional.',
      es: 'Esto es intencional.',
      ru: 'Это сделано намеренно.'
    },
    structure3: {
      en: 'Instead of random one-off bedtime stories, families can follow a steady rhythm — one story at a time, day by day. Over time, this builds familiarity, comfort, and a sense of safety.',
      es: 'En lugar de cuentos aislados, las familias pueden seguir un ritmo continuo que crea familiaridad y seguridad emocional.',
      ru: 'Вместо случайных историй — последовательность. День за днём формируется устойчивое ощущение безопасности.'
    },
    structure4: {
      en: 'A child who hears Nimny regularly begins to recognize the feeling:\n"It\'s night now. I don\'t have to solve everything."',
      es: 'Con el tiempo, el niño reconoce la sensación:\n"Es de noche. No tengo que resolverlo todo ahora."',
      ru: 'Ребёнок постепенно начинает узнавать состояние:\n«Наступила ночь. Я могу ничего не решать.»'
    },
    structureMyStories: {
      en: 'When you create your own stories, they\'re saved to My Stories — so you can return to them anytime.',
      es: 'Los cuentos que crees se guardan en Mis Cuentos — para volver a ellos cuando quieras.',
      ru: 'Созданные истории сохраняются в Мои Истории — к ним можно вернуться в любой момент.'
    },
    forWhomTitle: {
      en: 'Who Nimny is for',
      es: '¿Para quién es Nimny?',
      ru: 'Для кого Нимни'
    },
    forWhomIntro: {
      en: 'Nimny bedtime stories are especially helpful for children who:',
      es: 'Nimny es ideal para niños que:',
      ru: 'Сказки Нимни особенно подходят детям, которые:'
    },
    forWhomList: {
      en: ['think a lot at night', 'struggle to calm down before sleep', 'feel big emotions in small moments', 'get overwhelmed by fast-paced content', 'need a consistent bedtime routine'],
      es: ['piensan mucho por la noche', 'necesitan ayuda para calmarse', 'sienten emociones intensas', 'se saturan con contenido rápido', 'necesitan una rutina estable'],
      ru: ['много думают перед сном', 'тяжело переключаются с дня на ночь', 'остро чувствуют эмоции', 'перегружаются быстрым контентом', 'нуждаются в стабильном ритуале']
    },
    forWhomClosing: {
      en: 'Nimny is also for parents — especially those who want something gentle and meaningful without needing more screen time.',
      es: 'Nimny también es para los padres — especialmente los que buscan algo cálido y significativo, sin más tiempo de pantalla.',
      ru: 'Нимни — это ещё и поддержка для родителей. Для тех, кому важно тёплое общение без лишнего экрана.'
    },
    promiseTitle: {
      en: 'A quiet promise',
      es: 'Una promesa tranquila',
      ru: 'Тихое обещание'
    },
    promise1: {
      en: 'Nimny does not promise a perfect bedtime.',
      es: 'Nimny no promete una noche perfecta.',
      ru: 'Нимни не обещает идеальный вечер.'
    },
    promise2: {
      en: 'She promises something smaller:\na softer one.',
      es: 'Promete una más suave.',
      ru: 'Она обещает кое-что проще:\nмягкий вечер.'
    },
    promise3: {
      en: 'A night that feels safe enough to let the day go.',
      es: 'Una noche donde el día puede soltarse.',
      ru: 'Ночь, в которой можно отпустить день.'
    },
    // FAQ Section
    faqTitle: {
      en: 'Frequently Asked Questions',
      es: 'Preguntas Frecuentes',
      ru: 'Часто задаваемые вопросы'
    },
    faq: [
      {
        question: {
          en: 'At what age is Nimny suitable?',
          es: '¿Para qué edad es Nimny?',
          ru: 'Для какого возраста подходит Нимни?'
        },
        answer: {
          en: 'Nimny stories are designed for children approximately 3–12 years old. Younger children enjoy the rhythm and calm tone, while older children connect with the emotional depth and gentle themes.',
          es: 'Las historias de Nimny están pensadas para niños de aproximadamente 3 a 12 años. Los más pequeños disfrutan del ritmo y la calma; los mayores conectan con la profundidad emocional.',
          ru: 'Сказки Нимни подходят детям примерно от 3 до 12 лет. Малыши чувствуют ритм и спокойствие, а дети постарше — глубину и смысл.'
        }
      },
      {
        question: {
          en: 'Can I listen to the stories?',
          es: '¿Puedo escuchar las historias?',
          ru: 'Можно слушать сказки?'
        },
        answer: {
          en: 'Yes. Every story has a Play button — tap it and Nimny will narrate the story aloud. You can listen together or let your child drift off to a calm voice.',
          es: 'Sí. Cada historia tiene un botón Play — tócalo y Nimny narrará el cuento en voz alta. Pueden escuchar juntos o dejar que tu niño se relaje con una voz tranquila.',
          ru: 'Да. У каждой сказки есть кнопка Play — нажми, и Нимни расскажет её вслух. Можно слушать вместе или дать ребёнку уснуть под спокойный голос.'
        }
      },
      {
        question: {
          en: 'Can I create my own stories?',
          es: '¿Puedo crear mis propios cuentos?',
          ru: 'Можно создавать свои сказки?'
        },
        answer: {
          en: 'Yes. Share a theme, a feeling, or a moment from the day, and Nimny will shape a personalized bedtime story. Created stories are saved to My Stories and can be replayed anytime. Credits and subscription options are available in your Account.',
          es: 'Sí. Comparte un tema, una emoción o un momento del día, y Nimny creará un cuento personalizado. Los cuentos se guardan en Mis Cuentos y puedes volver a ellos cuando quieras. Los créditos y opciones de suscripción están en tu Cuenta.',
          ru: 'Да. Расскажи тему, настроение или момент дня — и Нимни создаст персональную сказку. Она сохранится в Мои Истории. Условия (кредиты и подписка) — в разделе Аккаунт.'
        }
      },
      {
        question: {
          en: 'What is Living Story Mode?',
          es: '¿Qué es el Modo Historia Viva?',
          ru: 'Что такое Режим Живой Истории?'
        },
        answer: {
          en: 'Living Story Mode is an interactive experience where Nimny gently asks your child 2–3 questions during the story. Their answers shape how the tale unfolds — making each bedtime unique and personal.',
          es: 'El Modo Historia Viva es una experiencia interactiva donde Nimny hace 2–3 preguntas suaves durante el cuento. Las respuestas de tu niño dan forma a cómo se desarrolla la historia — cada noche es única.',
          ru: 'Режим Живой Истории — интерактивный формат. Нимни мягко задаёт ребёнку 2–3 вопроса по ходу сказки, и ответы влияют на сюжет. Каждый вечер становится уникальным.'
        }
      },
      {
        question: {
          en: 'Can Nimny talk in my language?',
          es: '¿Nimny puede hablar en mi idioma?',
          ru: 'Нимни говорит на моём языке?'
        },
        answer: {
          en: 'Yes. Nimny can tell stories and interact in more than 30 languages.\nSimply select your preferred language in Settings (Edit Family), and Nimny will adapt the stories and voice automatically.\nThe app interface is currently available in English, Spanish, and Russian.',
          es: 'Sí. Nimny puede contar historias e interactuar en más de 30 idiomas.\nSimplemente selecciona tu idioma preferido en Ajustes (Editar Familia) y Nimny adaptará las historias y la voz automáticamente.\nLa interfaz de la app está disponible actualmente en inglés, español y ruso.',
          ru: 'Да. Нимни может рассказывать сказки и общаться более чем на 30 языках.\nПросто выберите нужный язык в Настройках (Редактировать семью), и Нимни автоматически подстроит сказки и голос.\nИнтерфейс приложения на данный момент доступен на английском, испанском и русском.'
        }
      },
      {
        question: {
          en: 'Can I save and share stories?',
          es: '¿Puedo guardar y compartir cuentos?',
          ru: 'Можно сохранять и делиться сказками?'
        },
        answer: {
          en: 'Yes. All created stories are saved to My Stories automatically. You can also share a story link with family or friends.',
          es: 'Sí. Todos los cuentos creados se guardan en Mis Cuentos automáticamente. También puedes compartir un enlace con familia o amigos.',
          ru: 'Да. Все созданные сказки автоматически сохраняются в Мои Истории. Можно поделиться ссылкой с близкими.'
        }
      },
      {
        question: {
          en: 'Do the stories need to be read in order?',
          es: '¿Es necesario leer las historias en orden?',
          ru: 'Нужно ли читать сказки по порядку?'
        },
        answer: {
          en: 'Each story stands on its own. However, the weekly structure creates a soft emotional progression that builds a bedtime rhythm over time.',
          es: 'Cada historia funciona por sí sola. Sin embargo, la estructura semanal crea una progresión emocional suave que fortalece el ritual nocturno.',
          ru: 'Каждая сказка самостоятельна. Но недельная структура создаёт мягкое развитие и помогает выстроить вечерний ритуал.'
        }
      },
      {
        question: {
          en: 'Are Nimny stories educational?',
          es: '¿Son historias educativas?',
          ru: 'Это обучающие сказки?'
        },
        answer: {
          en: 'Nimny is not designed to teach lessons directly. Instead, it supports emotional regulation, connection, and reflection — helping children feel safe and understood.',
          es: 'Nimny no enseña lecciones directas. Su objetivo es apoyar la regulación emocional, la conexión y la calma antes de dormir.',
          ru: 'Нимни не учит напрямую. Эти сказки помогают ребёнку успокоиться, прожить день и почувствовать себя в безопасности.'
        }
      },
      {
        question: {
          en: 'Is Nimny a replacement for screen time?',
          es: '¿Sustituye al tiempo frente a pantallas?',
          ru: 'Это замена экранному времени?'
        },
        answer: {
          en: 'Nimny is designed to be read aloud or listened to together. It encourages calm, screen-free connection between parent and child, especially during evening transitions.',
          es: 'Nimny está diseñado para leerse en voz alta o escucharse juntos, fomentando conexión tranquila sin pantallas entre padres e hijos.',
          ru: 'Сказки Нимни созданы для чтения вслух или совместного прослушивания. Это спокойное время вместе — без лишнего экрана.'
        }
      },
      {
        question: {
          en: 'How long does each story take?',
          es: '¿Cuánto dura cada historia?',
          ru: 'Сколько длится одна сказка?'
        },
        answer: {
          en: 'Most stories take between 5–10 minutes when read slowly and calmly, or when listened to with Play.',
          es: 'Entre 5 y 10 minutos de lectura tranquila o escucha con Play.',
          ru: '5–10 минут спокойного чтения или прослушивания с Play.'
        }
      }
    ]
  },

  // Schema descriptions
  schema: {
    orgDescription: {
      en: 'Nimny is a collection of calming bedtime stories for children designed to be read aloud by parents.',
      es: 'Nimny es una colección de cuentos tranquilos para dormir diseñados para ser leídos en voz alta por los padres.',
      ru: 'Нимни — это коллекция спокойных сказок на ночь для детей, созданных для чтения вслух родителями.'
    }
  },

  // Contact Page
  contactPage: {
    metaTitle: {
      en: 'Help & Support – Nimny',
      es: 'Ayuda y Soporte – Nimny',
      ru: 'Помощь и поддержка – Нимни'
    },
    backToHome: {
      en: 'Back to home',
      es: 'Volver al inicio',
      ru: 'Вернуться на главную'
    },
    title: {
      en: 'Help & Support',
      es: 'Ayuda y Soporte',
      ru: 'Помощь и поддержка'
    },
    subtitle: {
      en: 'Need help? Send us a message below and we\'ll get back to you within 24 hours.',
      es: '¿Necesitas ayuda? Envíanos un mensaje a continuación y te responderemos en un plazo de 24 horas.',
      ru: 'Нужна помощь? Напишите нам ниже, и мы ответим в течение 24 часов.'
    },
    nameLabel: {
      en: 'Name',
      es: 'Nombre',
      ru: 'Имя'
    },
    optional: {
      en: '(optional)',
      es: '(opcional)',
      ru: '(необязательно)'
    },
    namePlaceholder: {
      en: 'Your name',
      es: 'Tu nombre',
      ru: 'Ваше имя'
    },
    emailLabel: {
      en: 'Email',
      es: 'Correo electrónico',
      ru: 'Электронная почта'
    },
    emailPlaceholder: {
      en: 'your@email.com',
      es: 'tu@correo.com',
      ru: 'ваш@email.com'
    },
    messageLabel: {
      en: 'Message',
      es: 'Mensaje',
      ru: 'Сообщение'
    },
    messagePlaceholder: {
      en: 'What would you like to tell us?',
      es: '¿Qué te gustaría decirnos?',
      ru: 'Что бы вы хотели нам сообщить?'
    },
    errorRequired: {
      en: 'Please fill in all required fields.',
      es: 'Por favor complete todos los campos requeridos.',
      ru: 'Пожалуйста, заполните все обязательные поля.'
    },
    errorGeneric: {
      en: 'Something went wrong. Please try again.',
      es: 'Algo salió mal. Por favor, inténtalo de nuevo.',
      ru: 'Что-то пошло не так. Пожалуйста, попробуйте снова.'
    },
    sending: {
      en: 'Sending...',
      es: 'Enviando...',
      ru: 'Отправка...'
    },
    sendButton: {
      en: 'Send Message',
      es: 'Enviar mensaje',
      ru: 'Отправить сообщение'
    },
    thankYou: {
      en: 'Your message has been sent.',
      es: 'Tu mensaje ha sido enviado.',
      ru: 'Ваше сообщение отправлено.'
    },
    thankYouMessage: {
      en: "We'll get back to you within 24 hours.",
      es: 'Te responderemos en un plazo de 24 horas.',
      ru: 'Мы ответим вам в течение 24 часов.'
    }
  },

  // Privacy Page
  privacyPage: {
    metaTitle: {
      en: 'Privacy Policy – Nimny Bedtime Stories',
      es: 'Política de privacidad – Cuentos de Nimny para dormir',
      ru: 'Политика конфиденциальности – Сказки на ночь Нимни'
    },
    backToHome: {
      en: 'Back to home',
      es: 'Volver al inicio',
      ru: 'Вернуться на главную'
    },
    title: {
      en: 'Privacy Policy',
      es: 'Política de privacidad',
      ru: 'Политика конфиденциальности'
    },
    whatWeCollect: {
      title: {
        en: 'What we collect',
        es: 'Qué recopilamos',
        ru: 'Что мы собираем'
      },
      content: {
        en: "When you subscribe to our email list, we collect your email address. That's it. We keep things simple.",
        es: 'Cuando te suscribes a nuestra lista de correo, recopilamos tu dirección de correo electrónico. Eso es todo. Mantenemos las cosas simples.',
        ru: 'Когда вы подписываетесь на нашу рассылку, мы собираем ваш адрес электронной почты. Это всё. Мы стараемся быть простыми.'
      }
    },
    howWeUse: {
      title: {
        en: 'How we use it',
        es: 'Cómo lo usamos',
        ru: 'Как мы это используем'
      },
      content: {
        en: "We use your email address only to send you updates about new Nimny stories. We won't email you about anything else.",
        es: 'Usamos tu correo electrónico solo para enviarte actualizaciones sobre nuevas historias de Nimny. No te enviaremos correos sobre nada más.',
        ru: 'Мы используем ваш адрес электронной почты только для отправки обновлений о новых историях Нимни. Мы не будем отправлять вам письма о чём-либо другом.'
      }
    },
    whatWeDont: {
      title: {
        en: "What we don't do",
        es: 'Qué no hacemos',
        ru: 'Чего мы не делаем'
      },
      items: {
        en: [
          "We don't sell your information to anyone.",
          "We don't share your email with third parties.",
          "We don't send spam or promotional content from other companies."
        ],
        es: [
          'No vendemos tu información a nadie.',
          'No compartimos tu correo con terceros.',
          'No enviamos spam ni contenido promocional de otras empresas.'
        ],
        ru: [
          'Мы не продаём вашу информацию никому.',
          'Мы не передаём ваш адрес третьим лицам.',
          'Мы не рассылаем спам или рекламный контент от других компаний.'
        ]
      }
    },
    analytics: {
      title: {
        en: 'Analytics',
        es: 'Analíticas',
        ru: 'Аналитика'
      },
      content: {
        en: "We may use basic analytics to understand how visitors use our website. This helps us make it better. We don't track you across other sites.",
        es: 'Podemos usar análisis básicos para entender cómo los visitantes usan nuestro sitio web. Esto nos ayuda a mejorarlo. No te rastreamos en otros sitios.',
        ru: 'Мы можем использовать базовую аналитику, чтобы понять, как посетители используют наш сайт. Это помогает нам улучшить его. Мы не отслеживаем вас на других сайтах.'
      }
    },
    yourChoices: {
      title: {
        en: 'Your choices',
        es: 'Tus opciones',
        ru: 'Ваши права'
      },
      content: {
        en: 'You can unsubscribe from our emails at any time using the link in any email we send. If you\'d like us to delete your information, please',
        es: 'Puedes darte de baja de nuestros correos en cualquier momento usando el enlace en cualquier correo que enviemos. Si deseas que eliminemos tu información, por favor',
        ru: 'Вы можете отписаться от наших писем в любое время, используя ссылку в любом письме, которое мы отправляем. Если вы хотите, чтобы мы удалили вашу информацию, пожалуйста,'
      },
      contactUs: {
        en: 'contact us',
        es: 'contáctanos',
        ru: 'свяжитесь с нами'
      }
    },
    questions: {
      title: {
        en: 'Questions?',
        es: '¿Preguntas?',
        ru: 'Вопросы?'
      },
      content: {
        en: 'If you have any questions about this policy, please reach out through our',
        es: 'Si tienes alguna pregunta sobre esta política, por favor contáctanos a través de nuestra',
        ru: 'Если у вас есть вопросы об этой политике, пожалуйста, свяжитесь с нами через нашу'
      },
      contactPage: {
        en: 'contact page',
        es: 'página de contacto',
        ru: 'страницу контактов'
      }
    },
    lastUpdated: {
      en: 'Last updated: January 2025',
      es: 'Última actualización: enero de 2025',
      ru: 'Последнее обновление: январь 2025'
    }
  }
};

// Links
export const LINKS = {
  amazon: 'https://www.amazon.com/dp/B0GJZV1643',
  nightJournal: 'https://www.amazon.com/dp/B0HG44SZBF',
  nimnyApp: 'https://nimny.app'
};

// Get language-aware nimny.app URL (path-based)
// Points directly to Month One (Bedtime Stories library) so users skip the app landing.
export const getNimnyAppUrl = (language) => {
  // Map language codes to app paths
  const langMap = {
    en: 'en',
    es: 'es', 
    ru: 'ru'
  };
  const lang = langMap[language] || 'en';
  return `https://nimny.app/${lang}/month-one`;
};

// Nimny avatar image (with transparency/rounded corners)
export const NIMNY_AVATAR = '/assets/nimny-avatar-new.webp';
